import { cellRenderPopupActM3 } from '../../PopupActMVP/functionPopupAct';
import { cellRenderParseData, cellRenderStatusAct } from '../../../utils/functions';

const columnDataMX3 = [
  {
    dataField: 'mh3',
    caption: 'МХ-3',
    cellRender: cellRenderPopupActM3,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'mh3NumId',
    caption: 'id МХ-3',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh3DocStatus',
    caption: 'id МХ-3 Doc Status',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh3Date',
    caption: 'Дата МХ-3',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'mh3Status',
    caption: 'Выкуп МХ-3',
    dataType: 'string'
  },
  {
    dataField: 'mh3DocStatusDescr',
    caption: 'Статус акта МХ-3',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  }
];
export default columnDataMX3;
